import { useState, useCallback } from 'react'
import { useDebounce } from './useDebounce'

export function useSearchWithDebounce(initialValue: string = '', delay: number = 500) {
  const [searchValue, setSearchValue] = useState(initialValue)
  const debouncedSearchValue = useDebounce(searchValue, delay)

  const handleSearchChange = useCallback((value: string) => {
    setSearchValue(value)
  }, [])

  const clearSearch = useCallback(() => {
    setSearchValue('')
  }, [])

  return {
    searchValue,
    debouncedSearchValue,
    handleSearchChange,
    clearSearch
  }
}
